export default class RicevutaDettaglio {
    id?: number;
    ricevutaId?: number;
    descrizione?: string;
    quantita?: number;
    unitaMisura?: string;
    prezzoUnitario?: number;
    prezzoTotale?: number;
    aliquotaIVA?: number;
    articoloId?: number;

    constructor() {
    }

    static fromJSON(json: any): RicevutaDettaglio {
        let result = new RicevutaDettaglio();
        result.id = json.id;
        result.ricevutaId = json.ricevutaId;
        result.descrizione = json.descrizione;
        result.quantita = Number(json.quantita);
        result.unitaMisura = json.unitaMisura;
        result.prezzoUnitario = Number(json.prezzoUnitario);
        result.prezzoTotale = Number(json.prezzoTotale);
        result.aliquotaIVA = Number(json.aliquotaIVA);
        result.articoloId = json.articoloId;
        return result;
    }
}
